import styled, { ThemedCssFunction, css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0rem;

  h3 {
    font-family: DM Sans, sans-serif;
  }
`;

type IconContainerVariants = "light" | "dark";

type IconContainerProps = {
  variant: IconContainerVariants;
};

const iconContainerVariants = {
  light: css`
    background-color: var(--black-300);
  `,
  dark: css`
    background-color: var(--black-100);
  `,
};

export const IconContainer = styled.div<IconContainerProps>`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.2rem;
  border-radius: 4px;

  svg {
    width: 19px;
    height: 19px;
  }

  ${({ variant }) => iconContainerVariants[variant]}
`;
